export default function DomLoaded(callback) {
  // `DOMContentLoaded` may fire before your script has a chance to run, so check before adding a listener
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', callback);
  } else {
    // `DOMContentLoaded` already fired
    callback();
  }
}
